export default "__VITE_ASSET__ca1153f8__"